import profile from './profile.jpg';
import me1 from './me1.jpg';
import me2 from './me2.jpg';
import me3 from './me3.jpg';
import me4 from './me4.jpg';
import me5 from './me5.jpg';

const profilePics = [profile, me1, me2, me3, me4, me5];

export default profilePics;